import { ZClassUnsafe } from "./ZClassRow";

export const getParentClassId = (
  classData: ZClassUnsafe,
): string | undefined => {
  const firstHierarchy = classData.parents?.[0];
  return firstHierarchy?.[0]?.id ?? "";
};
